import { styled } from '@mui/material';

export const ErrorContainer = styled('div')(() => ({
  position: 'absolute',
  width: '100%',
  top: '50vh',
  fontSize: '40px',
  textAlign: 'center',
}));
